module.exports = __webpack_public_path__ + "img/card0.1cbaeda2.png";